import { Brand } from '@promoboxx/graphql-gateway-types'
import { makeStyles } from 'tss-react/mui'

import SmartImage from '@src/components/shared/SmartImage'

import cloudinary from './Cloudinary'

const useStyles = makeStyles()((_theme) => ({
  root: { backgroundColor: 'transparent' },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}))

type BrandAvatarProps = StyleClassesProp<typeof useStyles> & {
  brand?: Pick<Brand, 'name' | 'logo_url'> | null
  size?: number
}

const BrandAvatar: React.FC<React.PropsWithChildren<BrandAvatarProps>> = (
  props,
) => {
  const { classes } = useStyles(undefined, {
    props,
  })
  const size = props.size ?? 40

  if (!props.brand) {
    return null
  }

  return (
    <div
      className={classes.root}
      style={{ width: size, height: size / (16 / 9) }}
    >
      <SmartImage
        alt={props.brand.name || ''}
        fallbackSrc={cloudinary
          .instance()
          .url('preview-defaults/campaign-default')}
        src={props.brand.logo_url}
        className={classes.image}
      />
    </div>
  )
}

export default BrandAvatar
